// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // <-- NUEVO

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD-yEbAvDquqSvuLWC9bBVNaSAGG04hQD4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sportfolio-fotos.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sportfolio-fotos",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sportfolio-fotos.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "109992076354",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:109992076354:web:44ee3806f97eecc04d79db"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Obtener instancias
export const db = getFirestore(app);
export const auth = getAuth(app); // <-- NUEVO

console.log('✅ Firebase configurado');